module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-insurance-525f4d0e0f7113a0999e2b6b6e9ccb55.jpg";